import { useState } from "react";

const links = [
  { label: "本期主打", href: "#zhuanti" },
  { label: "来龙去脉", href: "#laiqu" },
  { label: "关键节点", href: "#guanjian" },
  { label: "深扒幕后", href: "#neimu" },
  { label: "更多事件", href: "#gengduo" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/80 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex max-w-[1240px] items-center justify-between gap-4 px-4 py-3.5 md:px-6">
        <a href="#top" className="flex cursor-pointer items-center gap-2.5">
          <span className="relative flex h-9 w-9 items-center justify-center overflow-hidden rounded-full bg-primary-500 font-heading text-lg font-bold text-background-50">
            瓜
          </span>
          <span className="font-heading text-xl font-bold leading-none tracking-tight text-foreground-950">
            五1吃瓜
          </span>
          <span className="mt-1 hidden rounded-sm border border-primary-200 bg-primary-50 px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide text-primary-700 md:inline">
            Issue · 2026
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="cursor-pointer whitespace-nowrap text-sm text-foreground-700 transition hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="#zhuanti"
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-foreground-200 px-4 py-2 text-sm text-foreground-800 transition hover:border-foreground-950 hover:text-foreground-950"
          >
            <i className="ri-notification-3-line h-4 w-4" />
            订阅更新
          </a>
          <a
            href="#laiqu"
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            看全貌
            <i className="ri-arrow-right-line h-4 w-4" />
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="菜单"
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-900 lg:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} h-5 w-5`} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block cursor-pointer border-b border-background-100 py-3 text-sm text-foreground-800 last:border-0"
            >
              {l.label}
            </a>
          ))}
          <div className="mt-3 flex gap-3">
            <a
              href="#zhuanti"
              onClick={() => setOpen(false)}
              className="flex-1 whitespace-nowrap rounded-md border border-foreground-200 px-4 py-2.5 text-center text-sm text-foreground-800"
            >
              订阅更新
            </a>
            <a
              href="#laiqu"
              onClick={() => setOpen(false)}
              className="flex-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50"
            >
              看全貌
            </a>
          </div>
        </div>
      )}
    </header>
  );
}